import { parseCoordinates } from 'features/evaluation-views/utils/parseCoordinates';
import * as yup from 'yup';
import { Constants } from '../constants';
import {
  dropdownOptional,
  dropdownRequired,
  nullableStringSchema,
  numberSchemaRequired,
  twoDecimalNumbersSchema,
  yearSchema,
} from './common';

export const blockSchema = yup.object({
  // Required fields
  variety: dropdownRequired,
  lotNumber: yup
    .string()
    .nullable()
    .required(Constants.errorMessages.FIELD_REQUIRED)
    .trim(),
  primaryEvaluator: dropdownRequired,
  trees: numberSchemaRequired,
  acres: twoDecimalNumbersSchema.required(
    Constants.errorMessages.FIELD_REQUIRED,
  ),
  district: dropdownRequired,

  // Optional fields
  secondaryEvaluator: dropdownOptional,
  subVariety: dropdownOptional,
  rootstock: dropdownOptional,
  county: dropdownOptional,
  area: dropdownOptional,
  yearPlanted: yearSchema,
  location: yup
    .string()
    .test(
      'is-valid-coordinates',
      'Location must be in the format "latitude, longitude".',
      value => {
        if (!value) {
          return true; // Allow empty value.
        }
        const location = parseCoordinates(value);

        return !!(location?.latitude && location?.longitude);
      },
    )
    .nullable(),
  notes: nullableStringSchema,
});
